// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap-word[data-v-46615e60]{word-wrap:break-word}.sticky-left[data-v-46615e60]{position:sticky;left:0;z-index:1}.sticky-right[data-v-46615e60]{position:sticky;right:0;z-index:2}.bg-col-primary[data-v-46615e60]{background-color:#edfdfc}", ""]);
// Exports
module.exports = exports;
